<template>
<rect x="3.5" y="3.5" width="13" height="13" rx="2.5" fill="currentColor"/>
</template>
